export default "__VITE_ASSET__pYyK5eV9__"